import { CellContext } from "@tanstack/react-table";
import { TagChip } from "components/BetterResponseTable/TagChip";
import { TagView } from "generated/graphql";

export function TagPreview({ row: { original } }: CellContext<TagView, unknown>) {
  return (
    <div className="flex flex-wrap items-center gap-1">
      <TagChip tag={original} />
      <TagChip tag={original} active />
    </div>
  );
}
